import MessageBox from "../../util/messageBox";
import Box from "@mui/material/Box";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
import {v4 as uuid} from 'uuid';
import * as React from "react";
import {TabPanel} from "../../components/other/tabPanel";
import {
    alpha,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    MenuItem,
    Modal,
    OutlinedInput,
    Paper,
    Select,
    Stack,
    Switch,
    Tooltip,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {TextFieldDebounce} from "../../controls/agyle/textFieldDebounce";
import DateTimePicker from "@mui/lab/DateTimePicker";
import config from "../../app/config";
import moment from "moment";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    announcements,
    deleteAnnouncement,
    loadAnnouncements,
    updateAnnouncement,
} from "../../store/reducers/announcement";
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import {hasPermission} from "../../store/reducers/user";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import {
    HourglassBottomRounded,
    SmsOutlined,
    ModeEditOutlineOutlined,
    AddRounded
} from "@mui/icons-material";
import {
    ErrorIcon,
    FilterIcon,
    InfoIcon,
    NoteIcon,
    WarningIcon,
} from "../../components/icons/icons";
import clsx from "clsx";
import InformationBox from "../../components/other/informationBox";
import {StyledTab, StyledTabs} from "./admin";
import AgyleTextField from '../../components/ui/fields/agyleTextField';

const useStyles = makeStyles((theme) => ({
    userPreferences: {
        padding: "25px",
    },
    userPreferencesAddSection: {
        marginTop: "8px",
        paddingLeft: "25px",
        paddingRight: "25px"
    },
    userSpecialty: {
        display: "inline-block",
        fontWeight: "500"
    },
    specialtyRemove: {
        display: "inline-block",
        paddingLeft: "10px"
    },
    btnRemoveIcon: {
        background: "red",
    },
    modalSmall: {
      background: theme.palette.background.default,
      color: 'black',
        padding: '5px',
        paddingTop: '15px',
      width: '40%',
        left: '35%',
        top: '20%',
        position: 'absolute',
        border: '2px solid #000',
        height: '30%',
        overflow: 'auto',
        borderRadius: '10px',

    },
    modalBody: {
        background: "white",
        color: "black",
        width: "60%",
        left: "20%",
        position: "absolute",
        top: "30px",
        padding: "20px",
        height: "90%",
        overflow: "auto",
        fontSize: "13px",
        borderRadius: "6px"
    },
    modalIcon: {
        fontSize: 38
    },
    textGridItem: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10
    },
    iconGridItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 10,
        textAlign: "center",
        fontWeight: "bold",
    },
    iso: {
        fontWeight: "bold",
    },
    icon: {
        cursor: "pointer",
        width: 24,
        height: 24
    },
    backgroundDialog: {
        backgroundColor: theme.palette.background.default,
    },
    dialogTitle: {
        textAlign: "center",
        padding: "10px",
        fontSize: "x-large"
    },
    dialogContent: {
        height: "auto",
        '&::-webkit-scrollbar': {
            width: '0.6em'
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            outline: '1px solid slategrey'
        }
    },
    paper: {
        padding: 10,
        margin: "25px 0 10px 0",
        borderRadius: "7px",
        border: '1px solid #448FFF',
        background: theme.palette.background.paper,
    },
    input: {
        width: "100%",
        fontSize: "15px",
        marginBottom: 10,
        backgroundColor: theme.palette.background.paper,
        borderRadius: "6%",
        flexGrow: 5

    },
    button: {
      //  marginTop: 15,
        width: "100%",
        background: '#448FFF'
    },
    zoomModal: {
        position: "absolute",
        width: "auto",
        right: "10px",
        padding: "5px",
        background: theme.palette.background.default,
        border: `1px solid ${theme.palette.background.paper}`,
        borderRadius: "7px",
        zIndex: 1,
    },
    zoomItem: {
        fontSize: "small",
        width: "100%",
        justifyContent: "left"
    },
    group: {
        padding: "1px 1px",
        display: "inline-block",
        cursor: "pointer",
        width: "100%",
        wordWrap: "break-word"
    },
    optionsContainer: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        marginBottom: 20,
        padding: 15,
    },
    optionsTitle: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "x-large"
    },
    optionsDivider: {
        marginTop: 10,
        marginBottom: 10
    },
    moreSpec: {
        marginRight: 5
    },
    addButton: {
        background: '#448FFF',
        height: "30px",
        right: "0",
        position: "absolute",
        top: "10px"
    },
    firstRowItem: {
        margin: "13px 0px",
    },
    modalButtons:{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px'
    },
    buttonAgyle: {
        background: '#448FFF',
    },
    firstRowItems: {
        display: 'flex',
        marginBottom: 15,
        marginTop: 15,
        alignItems: 'center'
    },
    textContainer: {

        flexGrow: 1,
        margin: '10 10px',
        marginLeft: '5px'
    },
    agyleSwitch: {
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: '#448FFF',
            '&:hover': {
                backgroundColor: alpha('#448FFF', theme.palette.action.hoverOpacity),
            },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#448FFF',
        },
    },
    "@keyframes blinker": {
        from: { border: '3px solid #448FFF' },
        to: { border: '3px solid transparent' }
    },
    blink: {
        animationName: "$blinker",
        animationDuration: "2s",
        animationTimingFunction: "linear",
        animationIterationCount: "infinite",
        // color: "#448FFF"
    },
    typeSelect: {
        width: 150,
        height: 50,
        marginLeft: '15px'
    },
    typeSelectItem: {
        display: 'flex',
        alignItems: 'center'
    },
    typeSelectLabel: {
        display: 'flex',
        alignItems: 'center'
    },
    typeSelectIcon: {
        marginRight: '10px',
        marginBottom:'-3px'
    },
    textGridContainer: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center'
    },
    textContainerIcon: {
        display: 'flex',
        alignItems:'center',
        maxWidth: 'initial',
        margin: "12px 7px",
        textAlign: 'center'
    },
    switchGridSection: {
        display: "flex",
        marginLeft: "45px",
        marginBottom: "15px"
    },
    newAnnouncementButtons: {
        display: 'flex',
        gap: '20px',
        justifyContent: 'flex-start',
        marginRight: '10px'
    },
    filterButton:{
        position: 'relative'
    },
    filterContainer: {
        backgroundColor: theme.palette.background.paper,
        padding: '10px',
        paddingLeft: '20px',
        position: 'absolute',
        display: 'none',
        top: '52px',
        left: '220px',
        border: '1px solid #448FFF',
        transition: 'all 0.5s ease-in-out',
        borderRadius: '5px',

    },
    filterActive: {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 50
    },
    indicator: {
        backgroundColor: "#448FFF"
    }
}));

const systemOptions = () => {
    let options = [];
    let system = config.modules.admin.system;
    switch(system){
        case "BOTH": {
            options.push("AGYLE");
            options.push("UCR");
            break;
        }
        case "AGYLE": {
            options.push("AGYLE");
            break;
        }
        case "UCR": {
            options.push("UCR")
        }
        default: {
            break;
        }
    }

    if (config?.modules?.admin?.edWaitAnnouncements) options.push('ED WAIT');
    return options;
}

export const announcementTypes = [
    {
        value: "ERROR",
        label: "Error",
        icon: <ErrorIcon/>
    },
    {
        value: "INFO",
        label: "Info",
        icon: <InfoIcon/>,
    },
    {
        value: "NOTE",
        label: "Note",
        icon: <NoteIcon/>,
    },
    {
        value: "WARNING",
        label: "Warning",
        icon: <WarningIcon/>,
    },
]

export const announcementIcon = (type) => {
    return _.find(announcementTypes, {value: type}).icon
}

function AnnouncementAdmin(props) {
    const [value, setValue] = React.useState(0);
    const [newAnnouncement, setNewAnnouncement] = React.useState(null);
    const [announcementValues, setAnnouncementValues] = React.useState([]);
    const [announcementCopies, setAnnouncementCopies] = React.useState([]);
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const deleteID = React.useRef(null);
    const [confirmDeleteAnnouncement, setConfirmDeleteAnnouncement] = React.useState(false);
    const [announcementFilterVisible, setAnnouncementFilterVisible] = React.useState(false);
    const [announcementFilter, setAnnouncementFilter] = React.useState({
        "enabled": false,
        "type": [],
    })
    const [filterActive, setFilterActive] = React.useState(false);
    const [filteredValues, setFilteredValues] = React.useState([]);

    const init = {
        text: "",
        type: "INFO",
        counter: false,
        system: "AGYLE",
        editable: true,
        datePickerOpen: false,
        id: uuid(),
        countdownTo: null
    };

    const saveAnnouncements = (element) => {
        if (element.text !== "") {
            dispatch(updateAnnouncement(element));
        }
    };

    const getSystem = (announcement, system) => {
        let newType;
        const sysOptions = systemOptions();

        if(system === "AGYLE") {
            if(announcement.system === "ED WAIT") newType = "AGYLE"
            if(announcement.system === "UCR" && sysOptions.includes("AGYLE")) newType = "BOTH"
            if(announcement.system === "BOTH" && sysOptions.includes("UCR")) newType = "UCR"
            if(announcement.system === system && sysOptions.includes("UCR")) newType = "UCR"
        }
        if(system === "UCR") {
            if(announcement.system === "ED WAIT") newType = "UCR"
            if(announcement.system === "AGYLE" && sysOptions.includes("UCR")) newType = "BOTH"
            if(announcement.system === "BOTH" && sysOptions.includes("AGYLE")) newType = "AGYLE"
            if(announcement.system === system && sysOptions.includes("AGYLE")) newType = "AGYLE"
        }
        if(system === 'ED WAIT') {
            newType = 'ED WAIT'
        }

        if (!system) {
            if (sysOptions.includes("AGYLE")) newType = 'AGYLE'
            else if (sysOptions.includes("UCR")) newType = 'UCR';
        }

        return newType
    }


    useEffect(() => {
        if(!newAnnouncement)
            setNewAnnouncement(init);
    },[newAnnouncement])

    useEffect(() => {
        const tempAnnouncements = announcementValues.map(announcement => ({...announcement, editable: false, datePickerOpen: false}));
        setAnnouncementCopies(tempAnnouncements);
    }, [announcementValues.length]);

    const handleChangeAnnouncement = (event, system) => {
        const {name, id} = event.target;
        const value = event.target[name];

        // Make a shallow copy of the current `announcements`.
        const newArray = [...announcementValues];

        // Find index and update the changed item.
        let index = _.findIndex(newArray, {"id": id});
        if (index !== -1) {
            let obj = {...newArray[index]};

            switch (name) {
                case "value": {
                    obj = {
                        ...obj,
                        text: value
                    };
                    break;
                }
                case "checked": {
                    obj = {
                        ...obj,
                        enabled: value
                    };
                    break;
                }
                case "counter": {
                    obj = {
                        ...obj,
                        counter: event.target.checked
                    };
                    break;
                }
                case "system": {
                    obj = {
                        ...obj,
                        system: getSystem(obj, system)
                    };
                    break;
                }
                // if Counter is disabled then insert null to countdown date
                case "countdownTo": {
                    obj = {
                        ...obj,
                        countdownTo:  event.target.value,
                        counter: true
                    };
                    break;
                }
                case "countdownToClear": {
                    obj = {
                        ...obj,
                        countdownTo:  null,
                        counter: false
                    };
                    break;
                }
                case "colour": {
                    obj = {
                        ...obj,
                        colour: value
                    };
                    break;
                }
            }
            newArray[index] = obj;
        }
        const tempAnnouncements = newArray.map(announcement => ({...announcement, editable: false, datePickerOpen: false}));

        // Set new value.
        setAnnouncementValues(newArray);
        setAnnouncementCopies(tempAnnouncements);

        // Auto dispatch new announcement version to db
        dispatch(updateAnnouncement(newArray[index]))
    };

    const handleChangeDateAnnouncement = (date, id, clear) => {
        handleChangeAnnouncement({target: {name: clear ? "countdownToClear" : "countdownTo", value: date, id}});
    };

    const openCloseField = ({key, value, element, copiedArr, setter}) => {
        const newArray = [...announcementValues];
        let index = _.findIndex(newArray, {"id": element.id});
        if (index !== -1) {
            let obj = {...newArray[index]};
            obj = {
                ...obj,
                [key]: value ? value : copiedArr ? !copiedArr[key] : !obj[key]
            }
            newArray[index] = obj;
            //console.log(obj);
            setDate(obj.countdownTo)
        }

        !setter && setAnnouncementCopies(newArray);
        setter && setter(newArray);
    };

    const toggleNewAnnouncementFields = ({key}) => {
        let copy = {...newAnnouncement};
        copy = {
            ...copy,
            [key]: !copy[key]
        }
        setNewAnnouncement(copy);
    }

    const handleChangeNewAnnouncementText = (event, system) => {
        const {value} = event.target;
        let copy = {...newAnnouncement};
        copy = {
            ...copy,
            "text": value
        }
        setNewAnnouncement(copy);
    }

    const changeType = (event, newAnnouncement, id) => {
        const {target: {value}} = event;

        handleChangeAnnouncement({target: {name: "colour", colour: value, id}});

       // newAnnouncement && setNewAnnouncement(prevState => ({...prevState, colour: value}))
      //  !newAnnouncement && setAnnouncementValues(prevState => prevState.map(announcement => announcement.id === id ? {...announcement, colour: value} : announcement))
    }

    const submitNewAnnouncement = () => {
        if(newAnnouncement.text !== "Please enter new announcement text." && dispatch(hasPermission("CAN_ADD_ANNOUNCEMENT"))){
            let objToDispatch = {
                "id": null,
                "enabled": true,
                "text": newAnnouncement.text,
                "system": newAnnouncement.system,
                "colour": newAnnouncement.colour,
            }

            if(newAnnouncement.counter){
                objToDispatch = {
                    ...objToDispatch,
                    'counter': true,
                    'countdownTo': newAnnouncement.countdownTo
                }
            }
            dispatch(updateAnnouncement(objToDispatch));
            setAddAnnouncement(false);
            setNewAnnouncement(init);
        }
    };

    const handleChangeNewAnnouncementSystem = (event, system) => {
        const {value, name} = event.target;
        let copy = {...newAnnouncement};
        copy = {
            ...copy,
            system: getSystem(copy, system)
        };
        setNewAnnouncement(copy);
    }

    const addAnnouncementSection = () => {
        return (<Paper className={clsx(classes.paper, classes.blink)}>
                        <Grid
                            container
                            spacing={1}
                            direction={"row"}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={12} className={classes.firstRowItems}>
                                {/*Icon*/}
                                <Tooltip
                                    title={t("Change time for counter")}
                                >
                                    <IconButton
                                        onClick={() => toggleNewAnnouncementFields({key: "datePickerOpen"})}
                                        className={classes.firstRowItem}>
                                        <HourglassBottomRounded className={classes.icon}/>
                                    </IconButton>
                                </Tooltip>
                                    {newAnnouncement.datePickerOpen && (
                                        <Modal
                                            open={newAnnouncement.datePickerOpen || false}
                                            onClose={() => {toggleNewAnnouncementFields({key: "datePickerOpen"})}}
                                            aria-labelledby="parent-modal-title"
                                            aria-describedby="parent-modal-description"
                                        >
                                            <Box className={classes.modalSmall}>
                                                <DateTimePicker
                                                    label={t("Date and Time")}
                                                    inputFormat={config.defaultDateTimeFormat}
                                                    inputVariant="outlined"
                                                    clearable={true}
                                                    ampm={false}
                                                    value={newAnnouncement.countdownTo}
                                                    minDateTime={moment()}
                                                    onChange={(value) => {
                                                        setNewAnnouncement(prevState => ({...prevState, counter: true, countdownTo: value}))
                                                    }}
                                                    renderInput={(inp) => <TextField style={{width: "100%", margin: 0}} {...inp}
                                                                                 size={props.size}/>}
                                                />
                                                <div className={classes.modalButtons}>
                                                    <div>
                                                        <Button
                                                            onClick={() => {
                                                                toggleNewAnnouncementFields({key: "datePickerOpen"});
                                                                setNewAnnouncement(prevState => ({
                                                                    ...prevState,
                                                                    counter: false,
                                                                    countdownTo: null
                                                                }))
                                                            }}
                                                        >
                                                            {t("Cancel")}
                                                        </Button>

                                                        <Button
                                                            onClick={() => setNewAnnouncement(prevState => ({...prevState, countdownTo: null, counter: false}))}
                                                        >
                                                            {t("Clear")}
                                                        </Button>
                                                    </div>

                                                    <Button
                                                        className={classes.buttonAgyle}
                                                        variant='contained'
                                                        onClick={() => {
                                                            toggleNewAnnouncementFields({key: "datePickerOpen"});
                                                        }}
                                                    >
                                                        {t("Save")}
                                                    </Button>
                                                </div>
                                            </Box>

                                        </Modal>

                                    )}

                                {/*Date*/}
                                <div className={classes.firstRowItem}>
                                    {newAnnouncement.counter && moment(newAnnouncement.countdownTo).format(config.defaultDateTimeFormat)}
                                    {!newAnnouncement.counter && <span style={{color: "#FF6868"}}>{t("No countdown date set")}</span>}
                                </div>
                                {/*Type of announcement*/}
                                    <FormControl className={classes.typeSelect}>
                                        <Select
                                            value={newAnnouncement.colour}
                                            onChange={(event)=>{
                                                setNewAnnouncement(prevState => ({
                                                    ...prevState,
                                                    colour: event.target.value
                                                }))
                                            }}
                                            input={<OutlinedInput />}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Select type</em>;
                                                }
                                                return selected;
                                            }}
                                        >
                                            {announcementTypes.map((name) => (
                                                <MenuItem
                                                    className={classes.typeSelectItem}
                                                    key={name.label}
                                                    value={name.value}
                                                >
                                                    <div className={classes.typeSelectLabel}>
                                                        <div className={classes.typeSelectIcon}>{name.icon}</div>
                                                        <div>{name.label}</div>
                                                    </div>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                            </Grid>

                            <Grid item xs={12} className={classes.textGridContainer}>
                                {/*Icon*/}
                                <div className={classes.textContainerIcon}>
                                    <SmsOutlined className={classes.icon}/>
                                </div>

                                {/*Text Input*/}
                                    <div className={classes.textContainer}>
                                        {newAnnouncement.editable && <TextFieldDebounce
                                            id={newAnnouncement.id}
                                            name={"value"}
                                            label={t("Announcement Text")}
                                            fullEvent={true}
                                            className={classes.input}
                                            onChange={handleChangeNewAnnouncementText}
                                            value={newAnnouncement.text}
                                            variant="outlined"
                                            multiline
                                            placeholder={"Please enter new announcement text."}
                                        />
                                        }
                                        {!newAnnouncement.editable && <Typography variant="h6" style={{margin: '10px 0'}}>{newAnnouncement.text}</Typography>}
                                    </div>
                            </Grid>



                            {/*Switch section*/}
                            <Grid item className={classes.switchGridSection}>
                                <FormGroup>
                                    {systemOptions().map(option => {
                                        const systemSwitchIsChecked = newAnnouncement.system === option || (
                                            newAnnouncement.system === "BOTH" && (option === 'UCR' || option === 'AGYLE')
                                        );

                                        return (
                                            <FormControlLabel
                                                sx={{flex: "center"}}
                                                name={"system"}
                                                label={t(`For ${option}`)}
                                                control={
                                                    <Switch
                                                        className={classes.agyleSwitch}
                                                        checked={systemSwitchIsChecked}
                                                        onChange={(e)=>handleChangeNewAnnouncementSystem(e, option)}
                                                    />
                                                }
                                            />
                                        )
                                    })}
                                </FormGroup>
                            </Grid>

                            <Grid item xs={12} className={classes.newAnnouncementButtons}>
                                <Button
                                    variant='outlined'
                                    onClick={() => {
                                        setAddAnnouncement(false);
                                        setNewAnnouncement(init);
                                    }}
                                >
                                    {t("Cancel")}
                                </Button>
                                <Button
                                    variant={"contained"}
                                    className={classes.buttonAgyle}
                                    onClick={submitNewAnnouncement}>{t("Submit")}</Button>
                            </Grid>

                        </Grid>
                    </Paper>)
    }

    const [date, setDate] = React.useState(null);

    const renderAnnouncement = (element) => {
        const valueFromCopy = announcementCopies?.find(announcement => announcement.id === element.id);


        if (element && valueFromCopy) {
            return (
                systemOptions().includes("AGYLE") && (
                    <Paper className={classes.paper} key={element.id}>
                        <Grid
                        container
                        spacing={1}
                        direction={"row"}
                        justifyContent="space-between"
                        alignItems="center"
                        >
                        <Grid item xs={12} className={classes.firstRowItems}>
                            {/*Icon*/}
                            <Tooltip
                                title={t("Change time for counter")}
                            >
                                <IconButton
                                    onClick={() => openCloseField({key: "datePickerOpen", element, copiedArr: valueFromCopy})}
                                    className={classes.firstRowItem}>
                                    <HourglassBottomRounded className={classes.icon}/>
                                </IconButton>
                            </Tooltip>
                                {valueFromCopy.datePickerOpen && (
                                    <Modal
                                        open={valueFromCopy.datePickerOpen || false}
                                      //  onClose={() => openCloseField({key: "datePickerOpen", element, copiedArr: valueFromCopy})}
                                        aria-labelledby="parent-modal-title"
                                        aria-describedby="parent-modal-description"
                                    >
                                        <Box className={classes.modalSmall}>
                                            <DateTimePicker
                                                label={t("Date and Time")}
                                                inputFormat={config.defaultDateTimeFormat}
                                                inputVariant="outlined"
                                                clearable={true}
                                                ampm={false}
                                                value={date}
                                                minDateTime={moment()}
                                                onChange={(value) => {setDate(value)}}
                                                renderInput={(inp) => <TextField style={{width: "100%", margin: 0}} {...inp}
                                                                             size={props.size}/>}
                                            />
                                            <div className={classes.modalButtons}>
                                                <div>
                                                    <Button onClick={() => openCloseField({key: "datePickerOpen", element, copiedArr: valueFromCopy})}>
                                                        {t("Cancel")}
                                                    </Button>

                                                    <Button onClick={
                                                        () => handleChangeDateAnnouncement("a", element.id, "true")}
                                                    >
                                                        {t("Clear")}
                                                    </Button>
                                                </div>

                                                <Button
                                                    className={classes.buttonAgyle}
                                                    variant='contained'
                                                    onClick={() => {
                                                        handleChangeDateAnnouncement(date, element.id)
                                                        openCloseField({key: "datePickerOpen", copiedArr: valueFromCopy, element})
                                                    }
                                                }>
                                                    {t("Save")}
                                                </Button>
                                            </div>
                                        </Box>

                                    </Modal>

                                )}

                            {/*Date*/}
                            <div className={classes.firstRowItem}>
                                {element.counter && moment(element.countdownTo).format(config.defaultDateTimeFormat)}
                                {!element.counter && <span style={{color: "#FF6868"}}>{t("No countdown date set")}</span>}
                            </div>

                            {/*Type of announcement*/}
                                <FormControl className={classes.typeSelect}>
                                    <Select
                                        value={element.colour}
                                        onChange={e => changeType(e, false, element.id)}
                                        input={<OutlinedInput />}
                                        renderValue={(selected) => {
                                            if (selected.length === 0) {
                                                return <em>Select type</em>;
                                            }
                                            return selected;
                                        }}
                                    >
                                        {announcementTypes.map((name) => (
                                            <MenuItem
                                                className={classes.typeSelectItem}
                                                key={name.label}
                                                value={name.value}
                                            >
                                                <div className={classes.typeSelectLabel}>
                                                    <div className={classes.typeSelectIcon}>{name.icon}</div>
                                                    <div>{name.label}</div>
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                        </Grid>

                        <Grid item xs={12} className={classes.textGridContainer}>
                            {/*Icon*/}
                            <div className={classes.textContainerIcon}>
                                <SmsOutlined/>
                            </div>

                            {/*Text Input*/}
                                <div className={classes.textContainer}>
                                    {valueFromCopy.editable && <TextField
                                        id={element.id}
                                        name={"value"}
                                        label={t("Announcement Text")}
                                        fullEvent={true}
                                        className={classes.input}
                                        onBlur={handleChangeAnnouncement}
                                        defaultValue={element.text}
                                        variant="outlined"
                                        multiline
                                    />
                                    }
                                    {!valueFromCopy.editable && <Typography variant="h6" style={{margin: '10px 0'}}>{element.text}</Typography>}
                                </div>

                            {/*Edit Icon*/}
                                <IconButton
                                    aria-label="edit"
                                    onClick={() => openCloseField({key: "editable", element, copiedArr: valueFromCopy})}
                                    style={{margin: "12px 7px"}}
                                >
                                    <ModeEditOutlineOutlined />
                                </IconButton>
                        </Grid>


                        {/*Switch section*/}
                        <Grid item xs={6} style={{display: 'flex'}}>
                            <div style={{display: 'flex', alignItems:'center', marginLeft:'3px'}}>
                                <IconButton
                                onClick={() => {
                                    deleteID.current = element.id;
                                    setConfirmDeleteAnnouncement(true);
                                }}
                                color={"error"}
                                size="small"
                                variant="outlined"
                                >
                                    <DeleteIcon/>
                                </IconButton>
                                <FormGroup>
                                    <FormControlLabel
                                        sx={{flex: "center", marginLeft: 1}}
                                        name={"checked"}
                                        control={
                                        <Switch
                                            className={classes.agyleSwitch}
                                            checked={element.enabled}
                                            onChange={handleChangeAnnouncement}
                                            id={element.id}/>
                                        }
                                        label={t("Enabled")}/>
                                </FormGroup>
                            </div>
                            <Divider orientation="vertical" flexItem style={{margin: "0 20px"}}/>
                            <div>
                                <FormGroup>
                                    {systemOptions().length > 1 && systemOptions().map(option => {
                                        return (
                                            <FormControlLabel
                                                sx={{flex: "center"}}
                                                name={"system"}
                                                key={option}
                                                control={
                                                    <Switch
                                                        className={classes.agyleSwitch}
                                                        checked={element.system === option || element.system === 'BOTH'}
                                                        id={element.id}
                                                        onChange={(e)=>handleChangeAnnouncement(e, option)}
                                                    />}
                                                label={t(`For ${option}`)}/>
                                        )
                                    })
                                    }
                                </FormGroup>
                            </div>
                        </Grid>

                        {/*<Grid item xs={3} >*/}
                        {/*    <Button*/}
                        {/*        variant={"contained"}*/}
                        {/*        className={classes.button}*/}
                        {/*        onClick={() => saveAnnouncements(element)}*/}
                        {/*    >*/}
                        {/*        {t("Save")}*/}
                        {/*    </Button>*/}
                        {/*</Grid>*/}

                    </Grid>
                </Paper>)
            );
        }
        return undefined;
    };

    const announcementsObject = useSelector(announcements);

    useEffect(()=>{
        dispatch(loadAnnouncements());
    },[]);

    useEffect(() => {
        const temp = [];
        announcementsObject.map(item=> temp.unshift(item));
        setAnnouncementValues(temp);
    }, [announcementsObject]);

    const deleteAnnouncements = () => {
        setConfirmDeleteAnnouncement(false);
        if (deleteID.current && dispatch(hasPermission("CAN_ADD_ANNOUNCEMENT"))) {
            dispatch(deleteAnnouncement(deleteID.current));
            deleteID.current = null;
        }
    };

    const [addAnnouncement, setAddAnnouncement] = React.useState(false);
    const [announcementText, setAnnouncementText] = React.useState("");
    const [announcementView, setAnnouncementView] = React.useState(false);



    const handleChangeNewAnnouncement = (event) => {
        const {value} = event.target;
        setAnnouncementText(value);
    };

    const submitAnnouncement = () => {
        if (announcementText !== "" && dispatch(hasPermission("CAN_ADD_ANNOUNCEMENT"))) {
            const obj = {
                "id": null,
                "enabled": true,
                "text": announcementText,
            };
            dispatch(updateAnnouncement(obj));
            setAddAnnouncement(false);
            setAnnouncementText("");
        }
    };



    const handleChangeAnnouncementFilter = (event, enable) => {
        const {name} = event.target;
        const temp = {...announcementFilter};

        if (enable) {
            setAnnouncementFilter({
                ...temp,
                enabled: !temp.enabled
            })
        }

        if (name !== 'enabled') {
            if (!announcementFilter.type.includes(name)) {
                setAnnouncementFilter({
                    ...temp,
                    "type": [...temp.type, name],
                });
            } else {
                setAnnouncementFilter({
                    ...temp,
                    "type": temp.type.filter(item => item !== name),
                });
            }
        }
    }
    const renderFilterContainer = () => {
       return  (
           <Stack spacing={3} alignItems="center" justifyContent="flex-end" className={clsx(classes.filterContainer, announcementFilterVisible && classes.filterActive)} >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: '180px'
            }}>
                <Typography variant="h6" sx={{marginLeft: '-5px', marginBottom: "5px"}}>{t("Filter by")}</Typography>
                <FormControl
                    sx={{marginBottom: "10px"}}
                >
                    <FormGroup>
                        {announcementTypes.map(({ value,label}) => {
                            return (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={announcementFilter.type.includes(value)}
                                            onChange={handleChangeAnnouncementFilter} name={value}
                                        />}
                                    label={label}
                                    name={value}
                                    key={label}
                                />
                            )}
                        )}
                    </FormGroup>

                </FormControl>

                <FormControlLabel
                    control={
                        <Switch
                            className={classes.agyleSwitch}
                            checked={announcementFilter.enabled}
                            onChange={(e) => handleChangeAnnouncementFilter(e, true)}
                            name="enabled"
                        />
                    }
                    sx={{marginBottom: '5px'}}
                    label={t("Only enabled")}
                />
                <FormControlLabel
                    control={
                        <Switch
                            className={classes.agyleSwitch}
                            checked={filterActive}
                            onChange={() => setFilterActive(prev => !prev)}
                            label={t("Enable filters")}
                        />
                    }
                    label={t("Enable Filters")}
                />
            </div>
           </Stack>)
    }

    return (
        <React.Fragment>
            <Box sx={{ width: '100%' }}>
                <MessageBox
                    onClose={() => {
                        deleteID.current = null;
                        setConfirmDeleteAnnouncement(false);
                    }}
                    title={t("Confirmation")}
                    haveAccept={{yes: t("Submit"), no: t("Close")}}
                    onAccept={deleteAnnouncements}
                    message={t("Are you sure you want to delete this announcement?")}
                    open={confirmDeleteAnnouncement || false}
                />

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <StyledTabs value={value} aria-label="basic tabs example" TabIndicatorProps={{className: classes.indicator}}>
                    <StyledTab label="Announcement" />
                    <Button
                        onClick={() => setAnnouncementFilterVisible(prevState => !prevState)}
                    >
                        <FilterIcon width={22} height={22} />
                    </Button>
                    <Button
                        className={classes.addButton}
                        variant={"contained"}
                        onClick={() => setAddAnnouncement(true)}>{<AddRounded style={{marginLeft:'-5px', marginRight: '10px'}}/>}{t("Add")}</Button>
                </StyledTabs>
            </Box>
            <TabPanel value={value} index={0}>
                {renderFilterContainer()}
                {filterActive &&
                    (<InformationBox type={"info"}>
                            Filters are switched on! Only the filtered announcements will be displayed.
                    </InformationBox>)
                }
                {addAnnouncement && addAnnouncementSection()}
                {filterActive && announcementValues.map(element => {
                    const filtered = (announcementFilter.type.includes(element.type) || (announcementFilter.type.length === 0 && !element.type)) && announcementFilter.enabled === element.enabled;
                    if (filtered)
                        return renderAnnouncement(element)
                })}
                {!filterActive && announcementValues.map(element => {
                    return renderAnnouncement(element);
                })}
            </TabPanel>
        </Box>
        <Dialog
            open={false}
            maxWidth={"sm"}
            fullWidth={true}>
            <DialogTitle
                className={clsx(classes.backgroundDialog, classes.dialogTitle)}>
                {t("Add announcement")}
            </DialogTitle>

            <DialogContent className={clsx(classes.backgroundDialog, classes.dialogContent)} dividers>
                <Grid item xs={12}>
                    <TextFieldDebounce
                        name={"value"}
                        placeholder={t("Enter text")}
                        label={t("Text")}
                        className={classes.input}
                        onChange={handleChangeNewAnnouncement}
                        value={announcementText}
                        variant="outlined"
                        multiline
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

            </DialogContent>

            <DialogActions>
                <div style={{flex: '1 0 0'}}>
                    <Button color="tertiary" onClick={() => setAddAnnouncement(false)}>{t("Close")}</Button>
                </div>
                <div>
                    <Button
                        color="tertiary"
                        onClick={submitAnnouncement}>{t("Submit")}</Button>
                </div>
            </DialogActions>
        </Dialog>
        </React.Fragment>)
}

export default AnnouncementAdmin;